<template>
  <div class="content-right">
    <div class="content-wrapper container-xxl p-0">
      <div class="content-header row">
      </div>
      <div class="content-body">
        <div class="body-content-overlay"></div>
        <!-- Main project area -->
        <section class="chat-app-window">
          <!-- To load Conversation -->
          <div class="start-chat-area d-none">
            <div class="mb-1 start-chat-icon">
              <i data-feather="message-square"></i>
            </div>
            <h4 class="sidebar-toggle start-chat-text">Select Project</h4>
          </div>
          <!--/ To load Conversation -->

          <!-- Active Project -->
          <div class="active-chat">
            <!-- Project Header -->
            <div class="chat-navbar">
              <header class="chat-header">
                <div class="d-flex align-items-center">
                  <div @click="$emit('sidebarActiveInactive')" class="sidebar-toggle d-block d-lg-none me-1">
                    <i class="fas fa-bars"></i>
                  </div>
                  <div class="avatar bg-transparent avatar-border user-profile-toggle m-0 me-1">
                    <img :src="IconPath" width="42" class="border-0 rounded" :alt="projectOverview.name"/>
                  </div>
                  <h6 class="mb-0">
                    {{ projectOverview.name }}<br>
                    <small>{{ projectOverview.party?.name }}</small>
                  </h6>
                </div>
                <div @click="$emit('handleEdit', projectOverview.id)" class="d-flex align-items-center">
                  <i class="cursor-pointer fa fa-edit d-sm-block font-medium-2 me-1"></i>
                </div>
              </header>
            </div>
            <!--/ Project Header -->

            <!-- User Chat messages -->
            <div class="user-chats">
              <div class="chats">
                <ul class="nav nav-tabs">
                  <li v-for="tab in tabs" :key="tab.id" class="nav-item">
                    <a
                        :href="`#${tab.id}`"
                        :class="['nav-link', { active: activeTabId === tab.id }]"
                        @click="setActiveTab(tab)"
                    >
                      {{ tab.title }}
                    </a>
                  </li>
                </ul>
                <component :is="activeTab" :accountsBalance="accountsBalance"/>
              </div>
            </div>
            <!-- User Project messages -->
          </div>
          <!--/ Active Project -->
        </section>
        <!--/ Main project area -->
      </div>
    </div>
  </div>
</template>

<script setup>
import IconPath from '@/assets/check-circle.png';
import JobSummary from "@/views/page/company/procurement/project/job-register/tabs/JobSummary.vue";
import JobStatus from "@/views/page/company/procurement/project/job-register/tabs/JobStatus.vue";
import Document from "@/views/page/company/procurement/project/job-register/tabs/Document.vue";
import Financials from "@/views/page/company/procurement/project/job-register/tabs/Financials.vue";
import {ref} from "vue";

const activeTab = ref(JobSummary)
const activeTabId = ref('job_summary')
const props = defineProps({
  projectOverview: {
    type: Object,
    default: {
      project_accounts: [],
      party: {},
    }
  },
  accountsBalance: {
    type: Object,
    default: {
      income: [],
      expense: []
    }
  }
})

const tabs = [
  {id: 'job_summary', title: 'Job Summary', component: JobSummary},
  {id: 'job_status', title: 'Job Status', component: JobStatus},
  {id: 'documents', title: 'Documents', component: Document},
  {id: 'financials', title: 'Financials', component: Financials}
]

const setActiveTab = tab => {
  activeTab.value = tab.component;
  activeTabId.value = tab.id;
};
</script>

<style scoped>
.user-chats {
  background-image: none !important;
  overflow-y: scroll;
  height: calc(100% - 65px);
  overflow-x: hidden;
}
</style>
